import {SeoError} from './SeoError.js'

export class SeoMakeModelFaqsNotFoundError extends SeoError {}
